<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/layoutComponents/page-header'
import Table from '../../components/common/table/Table'
import TableHeader from '../../components/common/table/TableHeader'
import Pagination from '../../components/common/table/Pagination.vue'
import listDataProvider from '../../services/list'
import { invoiceMixins, ListsMixins, urlQueriesMixins } from '../../utils/mixins'
import Loader from '../../components/common/loader.vue'
import Excel from '../common/excel.vue'
import axios from 'axios'
import { API_URL } from '../../../config/HTTP.js'
import Toast from '../common/Toast.vue'
import walletDataProvider from '../../services/wallet'
import IvitationSetting from '../user/invitation/SettingModal'
import BlackListModal from '../user/invitation/BlackListModal'
import notificationsDataProvider from '../../services/notifications'
import CommentsSideCard from '../../components/comment/SideCard'
import dadbanPackageProvider from '../../services/dadban/package'
import dadbanCourseProvider from '../../services/dadban/course'
import moocCategoryProvider from '../../services/mooc/category'
import dadbananSettingProvider from '../../services/dadban/banners'
import dadbanUsersProvider from '../../services/dadban/user'
import moocUsersProvider from '../../services/mooc/user'
import moocPackageProvider from '../../services/mooc/package'
import dadbanDiscountProvider from '../../services/dadban/discount'
import AddCategory from '../mooc/categoury/AddCategory.vue'
import TeacherValidationModal from '../mooc/teachers/ValidationModal.vue'
import Reporting from '../mooc/reporting/Reporting.vue'
import HomeCategoryModal from '../dadban/banners/HomeCategoryModal.vue'
import moocCourseProvider from '../../services/mooc/course'
import dadbanCampaignProvider from '../../services/dadban/campaign.js'

export default {
  page: {
    title: 'لیست ها',
    meta: [
      {
        name: 'list',
        content: appConfig.description,
      },
    ],
  },
  mixins: [ListsMixins, urlQueriesMixins, invoiceMixins],
  components: {
    PageHeader,
    Table,
    TableHeader,
    Pagination,
    Loader,
    Excel,
    Toast,
    IvitationSetting,
    BlackListModal,
    CommentsSideCard,
    AddCategory,
    HomeCategoryModal,
    TeacherValidationModal,
    Reporting,
  },
  props: {
    checkedList: Array,
  },
  data() {
    return {
      categoryData: {},
      homeCategoryData: {},
      wannaExcel: null,
      fields: [],
      filtersQuery: [],
      rows: [],
      dropDownListItems: [
        { id: 1, count: 10, value: 'نمایش 10 تایی', isDefault: true },
        { id: 2, count: 20, value: 'نمایش 20 تایی', isDefault: false },
        { id: 3, count: 50, value: 'نمایش 50 تایی', isDefault: false },
      ],
      downloadLink: '',
      componentKey: 0,
      loading: false,
      tableLoading: false,
      dotLoading: false,
      staticTransactionPage: null,
      prevRoute: null,
      toastMode: null,
      toastText: '',
      showToast: null,
      toastKey: 1,
      reqResponse: null,
      IvitationSettingModel: false,
      BlackListModel: false,
      modalKey: 2,
      BlackListKey: 3,
      followUpData: [],
      list: [],
      focused: false,
      reportFilter: null,
      productPrice: 0,
    }
  },

  methods: {
    onSearch(params) {
      this.tableLoading = true
      this.reportFilter = params
      this.getData(this.handleReporting())
    },
    async fetchCategory(e) {
      let result

      try {
        if (this.$route.params.slug === 'universitycategorycourse') {
          result = await moocCategoryProvider.getCategorysCourse(Number(e.id))
        } else if (this.$route.params.slug === 'universitycategorypackage') {
          result = await moocCategoryProvider.getCategorysPackage(Number(e.id))
        }
        this.categoryData = result.data.data.output
      } catch (error) {
        console.log(error)
      }
    },
    async fetchHomeCategory(e) {
      try {
        const result = await dadbananSettingProvider.getHomeCategory(Number(e.id))
        if (result.status === 200) this.homeCategoryData = result.data.data.output
      } catch (error) {
        return false
      }
    },
    rowSelected(e) {
      const route = this.$route

      if (['universitycategorypackage', 'universitycategorycourse'].includes(route.params.slug)) {
        this.fetchCategory(e)
      }
      if (route.params.slug === 'homecategory') {
        this.fetchHomeCategory(e)
      }
    },
    catchErr(error) {
      // this.$router.go(-1)
      this.loading = null
      this.tableLoading = null
      this.dotLoading = null
      this.forceRerender()
      this.toastMode = true
      this.toastText = error || 'مشکلی پیش آمده است لطفا دوباره سعی کنید.'
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
        this.toastKey += 1
      }, 2000)
    },
    removeDuplicateFilters() {
      const query = { ...this.$route.query }

      if (Array.isArray(query.filters)) {
        query.filters = query.filters[1]
      } else if (typeof query.filters === 'string' && query.filters.includes('[object Object]')) {
        query.filters = null
      }

      this.$router.replace({ query })
    },
    getData(payload, force) {
      if (this.$route.name === 'courses-package' && this.$route.query.query) {
        this.fetchCoursePackage()
      }
      if (this.$route.name === 'comments') {
        this.handleCourseComments(this.$route)
      }

      if (this.$route.name === 'package-prerequisites' && this.$route.query.query) {
        this.fetchPackagePrerequisites()
      }
      if (this.$route.name === 'course-prerequisites' && this.$route.query.query) {
        this.fetchCoursePrerequisites()
      }
      if (this.$route.name === 'course-users') {
        this.fetchSearchUsers()
      }
      if (this.$route.name === 'campaign-detail') {
        this.fetchCampaignProducts()
      }

      if (this.$route.name === 'course-users') {
        payload = this.handleCourseUsers()
      }
      if (this.$route.path === '/list/percentorderwithpagination') {
        payload = this.handleReporting()
      }

      if (force) {
        payload = this.handleCourseUsers(force)
      }

      let fieldSearchs = []

      // this.removeDuplicateFilters()
      if (this.$route.query.filters) {
        this.$route.query.filters.forEach((element) => {
          fieldSearchs.push({ fieldName: element.fieldName, text: String(element.key) })
        })
      }

      if (fieldSearchs.length) {
        payload = { ...payload, fieldSearchs }
      }
      console.log(payload)

      if (this.$route.name === 'transactions-fromUserManagement') {
        walletDataProvider
          .getSpecificUserWalletTransactionsFromUsermanagement(payload)
          .then((res) => {
            this.reqResponse = res.data
            this.manageData()
          })
          .catch((err) => {
            this.catchErr()
          })
      } else if (this.$route.name === 'transactions-fromListsWallet') {
        walletDataProvider
          .getSpecificUserWalletTransactionsFromListsWallet(payload)
          .then((res) => {
            this.reqResponse = res.data
            this.manageData()
          })
          .catch((err) => {
            this.catchErr()
          })
      } else if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        dadbanDiscountProvider
          .getProductsTable(payload)
          .then((res) => {
            this.reqResponse = res.data
            this.manageData()
          })
          .catch((err) => {
            this.catchErr()
          })
      } else {
        listDataProvider
          .getListData(payload)
          .then((res) => {
            this.reqResponse = res.data
            // this.reqResponse.data.addRowPage.key = 'invitation'
            // this.reqResponse.data.addRowPage.link = 'invitation'
            this.manageData()
          })
          .catch((err) => {
            if (this.$route.path !== '/list/discount') {
              this.catchErr()
            }
          })
      }
    },
    manageData() {
      this.dotLoading = true
      this.$store.dispatch('lists/setDataList', this.reqResponse)
      this.fields = this.dataList.data.fields
      setTimeout(() => {
        this.rows = this.dataList.data.rows
      }, 200)
      this.filtersQuery = this.dataList.data.filters
      setTimeout(() => {
        if (this.$route.name !== 'course-users') {
          this.forceRerender()
        }
        this.loading = false
        this.tableLoading = false
        this.dotLoading = false
      }, 300)
    },
    excelDownload() {
      this.wannaExcel = null
      axios
        .post(
          `${API_URL}/Aggregator.Crm/api/Table/ExportToXlsx`,
          { key: this.routeParam, query: this.searchQuery, pageSize: this.pageSize, pageNumber: this.currentPage },
          { responseType: 'blob' },
        )
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          this.downloadLink = URL.createObjectURL(blob)
        })
    },
    addRow() {
      if (['universitycategorypackage', 'universitycategorycourse'].includes(this.$route.params.slug)) {
        this.$bvModal.show('categoryModal')
      } else if (this.$route.params.slug === 'homecategory') {
        this.$bvModal.show('homeCategoryModal')
      } else if (this.$route.path.includes('/list/posts')) {
        const router = this.$router.resolve({ name: 'dadban-add-posts' })

        window.open(router.href, '_blank')
      } else if (this.$route.params.slug.includes('universityteachers')) {
        this.$bvModal.show('teacherValidation')
      } else {
        this.$router.push({ path: `/list/${this.dataList.data.addRowPage.key}/add` })
      }
    },
    forceRerender() {
      this.componentKey += 1
    },
    invitaionSetting($event) {
      this.IvitationSettingModel = false
      this.modalKey += 1
      notificationsDataProvider.getFollowUp().then((res) => {
        this.followUpData = res.data.data
        setTimeout(() => {
          this.IvitationSettingModel = true
          this.modalKey += 1
        }, 200)
      })
    },
    blackListSetting($event) {
      this.BlackListModel = false
      this.BlackListKey += 1
      setTimeout(() => {
        this.BlackListModel = true
        this.BlackListKey += 1
      }, 200)
    },
    handleCourseComments(route) {
      const tmp = route.name.split('-')[1]
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10
      let statusCode = 0
      switch (tmp) {
        case 'waiting':
          statusCode = 1
          break
        case 'approved':
          statusCode = 2
          break
        case 'failed':
          statusCode = 3
          break
      }
      const commentsObj = (statusCode) => {
        const params = {
          key: route.path.includes('list/comments') ? 'allcomments' : this.$route.params.packageId ? 'packagecomments' : 'comments',
          pageNumber: parseInt(pageNumber),
          pageSize: parseInt(pageSize),
          query: this.$route.query.query,
          fieldSearchs: [
            {
              fieldName: route.path.includes('list/comments') ? 'ProductType' : route.path.includes('packagecomments') ? 'PackageId' : 'CourseId',
              type: 'string',
              text: route.path.includes('list/comments') ? '0' : route.params.courseId || route.params.packageId,
            },
            {
              fieldName: 'Status',
              type: 'string',
              text: statusCode.toString(),
            },
          ],
        }
        // if (this.$route.params.packageId) {
        //   params.key = 'packagecomments'
        // }
        return params
      }
      const queryParams = commentsObj(statusCode)
      return queryParams
    },
    handlePackegeCourses() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'packagecourses',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            type: 'string',
            text: route.params.packageId,
          },
        ],
      }
      if (route.path.includes('university')) {
        params.key = route.params.packageId ? 'universitypackagecourses' : 'packagecourses'
      }
      return params
    },
    handleCampaignProducts() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'campaignproducts',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        query: this.$store.state.urlQueries.searchQuery || '',
        fieldSearchs: [
          {
            fieldName: 'CampaignId',
            type: 'string',
            text: route.params.id ? route.params.id.toString() : route.params.id,
          },
        ],
      }
      return params
    },
    handleAllTransactions() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'alltransactions',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: undefined,
      }
      let fieldSearchs = []

      if (route.query.filters) {
        route.query.filters.forEach((element) => {
          fieldSearchs.push({ fieldName: 'IsIncreaseStatus', text: String(element.key) })
        })
      }
      if (fieldSearchs.length) {
        params.fieldSearchs = fieldSearchs
      }

      return params
    },
    handleCoursePrerequisites() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'courseprerequisites',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'CourseId',
            type: 'string',
            text: route.params.courseId,
          },
        ],
      }
      return params
    },
    handleIssuanceOfACertificate() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'universitylicensepeople',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'CourseId',
            type: 'string',
            text: route.params.courseId,
          },
        ],
      }
      return params
    },
    handlePage() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: route.params.slug,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
      }
      return params
    },
    handleHomeCategory() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: route.params.slug,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
      }
      return params
    },
    handleSlider() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: route.params.slug,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
      }
      return params
    },

    getLastMonthRange() {
      const today = new Date()
      const lastMonth = new Date()
      lastMonth.setMonth(today.getMonth() - 1)

      const startDate = new Date(lastMonth.getFullYear(), lastMonth.getMonth(), today.getDate())
      const endDate = today

      const formatDate = (date) => `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`

      return [formatDate(startDate), formatDate(endDate)]
    },

    handleReporting() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10
      let fieldSearches = []
      const filters = this.reportFilter
      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          const element = filters[key]
          if (element && element.length) {
            if (Array.isArray(element)) {
              fieldSearches.push({ fieldName: 'FromDate', type: 'string', text: element[0] }, { fieldName: 'ToDate', type: 'string', text: element[1] })
            }
          }
        }
      }
      if (!fieldSearches.length && !filters) {
        fieldSearches.push({ fieldName: 'FromDate', type: 'string', text: '2024-03-20T20:30:00.000Z' }, { fieldName: 'ToDate', type: 'string', text: '2024-03-22T20:30:00.000Z' })
      }
      const params = {
        key: 'percentorderwithpagination',
        query: this.searchQuery,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: fieldSearches,
      }
      return params
    },
    handleDiscountList() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'discount',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'Status',
            type: 'string',
            text: '-1',
          },
        ],
      }
      return params
    },
    handleComments() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'totalcomments',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        filters: route.query.filters ? route.query.filters : null,
        fieldSearchs: [
          {
            fieldName: 'Status',
            text: route.query.filters ? String(route.query.filters[0].key) : '0',
          },
        ],
      }
      return params
    },
    handleDiscountDetail() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'ProductType',
            type: 'string',
            text: this.$route.query.filters ? this.$route.query.filters.join() : '-1',
          },
        ],
      }
      return params
    },
    handlePackagePrerequisites() {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10

      const params = {
        key: 'packageprerequisites',
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        fieldSearchs: [
          {
            fieldName: 'PackageId',
            type: 'string',
            text: route.params.packageId,
          },
        ],
      }
      return params
    },
    handleCourseUsers(q) {
      const route = this.$route
      let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
      let pageSize = route.query.perPage ? route.query.perPage : 10
      const params = {
        query: q,
        pageNumber: parseInt(pageNumber),
        pageSize: parseInt(pageSize),
        key: route.params.courseId ? 'coursepeople' : 'packagepeople',
        fieldSearchs: [
          {
            fieldName: route.params.courseId ? 'CourseId' : 'PackageId',
            text: route.params.courseId || route.params.packageId,
          },
        ],
      }
      if (route.path.includes('university')) {
        params.key = route.params.courseId ? 'universitycoursepeople' : 'universitypackagepeople'
      }
      return params
    },
    async fetchCoursePackage() {
      let body = {
        packageId: +this.$route.params.packageId,
        query: this.$route.query.query || '',
      }
      let req
      if (this.$route.path.includes('university')) {
        req = await moocPackageProvider.searchPackageCourse(body)
        this.list = req.data.data.output
      } else {
        req = await dadbanPackageProvider.searchPackageCourse(body)
        this.list = req.data.data.output
      }
    },
    async fetchCoursePrerequisites() {
      const req = await dadbanCourseProvider.searchCoursePrerequisite({
        courseId: this.$route.params.courseId,
        query: this.$route.query.query || '',
      })
      this.list = req.data.data.output
    },
    async fetchCampaignProducts() {
      const req = await dadbanCampaignProvider.searchProduct({
        campaignId: this.$route.params.id,
        query: this.$store.state.urlQueries.searchQuery || '',
      })
      this.list = req.data.data.output
    },
    async fetchPackagePrerequisites() {
      const req = await dadbanPackageProvider.searchPackagePrerequisite({
        packageId: this.$route.params.packageId,
        query: this.$route.query.query || '',
      })
      this.list = req.data.data.output
    },
    async fetchSearchUsers() {
      const req = await dadbanUsersProvider.getSearchUsers(
        this.$store.state.urlQueries.searchQuery ? `?keyword=${this.$store.state.urlQueries.searchQuery || ''}&pageSize=100&pageNumber=1` : '?pageSize=100&pageNumber=1',
      )
      this.list = req.data.data
    },
    async deleteRow(item) {
      if (['universitycategorypackage', 'universitycategorycourse'].includes(this.$route.params.slug)) {
        if (this.$route.params.slug === 'universitycategorypackage') {
          try {
            const res = await moocCategoryProvider.deleteCategoryPackage(item.id)
            if (res.status === 200) this.getData(this.handlePage())
          } catch (error) {
            this.catchErr('این موضوع در حال استفاده است.')
          }
        } else if (this.$route.params.slug === 'universitycategorycourse') {
          try {
            const res = await moocCategoryProvider.deleteCategoryCourse(item.id)
            if (res.status === 200) this.getData(this.handlePage())
          } catch (error) {
            this.catchErr('این موضوع در حال استفاده است.')
          }
        }
      }
      if (this.$route.params.slug === 'homecategory') {
        try {
          const res = await dadbananSettingProvider.deleteHomeCategory(item.id)
          if (res.status === 200) this.getData(this.handleHomeCategory())
        } catch (error) {
          this.catchErr('این مورد قابل حذف نیست')
        }
      }
      if (this.$route.params.slug === 'slider') {
        try {
          const res = await dadbananSettingProvider.deleteBanner(item.id)
          if (res.status === 200) this.getData(this.handleSlider())
        } catch (error) {
          this.catchErr('این مورد قابل حذف نیست')
        }
      }
      if (this.$route.name === 'course-prerequisites') {
        dadbanCourseProvider
          .deleteCoursePrerequisite({
            courseId: this.$route.params.courseId,
            prerequisiteId: item.id,
          })
          .then((res) => {
            this.getData(this.handleCoursePrerequisites())
          })
      }
      if (this.$route.name === 'package-prerequisites') {
        dadbanPackageProvider
          .deletePackagePrerequisite({
            packageId: this.$route.params.packageId,
            prerequisiteId: item.id,
          })
          .then((res) => {
            this.getData(this.handlePackagePrerequisites())
          })
      }

      if (this.$route.name === 'course-users') {
        const query = `?Id=${item.id}&ProductType=${this.$route.params.courseId ? 0 : 1}`
        if (this.$route.path.includes('university')) {
          moocUsersProvider.deleteCourseUser(query).then((res) => {
            this.getData(this.handleCourseUsers())
          })
        } else {
          dadbanUsersProvider.deleteCourseUser(query).then((res) => {
            this.getData(this.handleCourseUsers())
          })
        }
      }

      if (this.$route.name === 'courses-package') {
        if (this.$route.path.includes('university')) {
          moocPackageProvider.deletePackageCourse({ courseId: item.id, packageId: this.$route.params.packageId }).then((res) => {
            this.getData(this.handlePackegeCourses())
          })
        } else {
          dadbanPackageProvider.deletePackageCourse({ courseId: item.id, packageId: this.$route.params.packageId }).then((res) => {
            this.getData(this.handlePackegeCourses())
          })
        }
      }
      if (this.$route.name === 'campaign-detail') {
        const type = item.items.find((t) => t.fieldName === 'EntityType').value
        if (typeof type === 'undefined') return
        dadbanCampaignProvider.deleteProduct({ campaignId: +this.$route.params.id, productId: +item.id, productType: type === 'بسته' ? 1 : 0 }).then(() => {
          this.getData(this.handleCampaignProducts())
          this.$emit('update')
        })
      }
    },
    updateData() {
      if (this.$route.name === 'course-prerequisites') {
        this.getData(this.handleCoursePrerequisites())
      }
      if (this.$route.name === 'package-prerequisites') {
        this.getData(this.handlePackagePrerequisites())
      }
      if (this.$route.name === 'courses-package') {
        this.getData(this.handlePackegeCourses())
      }
      if (this.$route.name === 'campaign-detail') {
        this.getData(this.handleCampaignProducts())
        this.$emit('update')
      }
      if (this.$route.name === 'course-users') {
        this.getData(this.handleCourseUsers())
      }

      if (this.$route.path === '/list/advertisings') {
        this.getData({
          Key: 'advertisings',
          query: '',
          filters: null,
          pageNumber: 1,
          pageSize: 10,
        })
      }

      if (this.$route.path === '/list/percentorderwithpagination') {
        this.getData(this.handleReporting())
      }
    },
    handleSearchFocus() {
      this.focus = true
      if (this.$route.name === 'course-prerequisites') {
        this.fetchCoursePrerequisites()
      }
      if (this.$route.name === 'package-prerequisites') {
        this.fetchPackagePrerequisites()
      }
      if (this.$route.name === 'courses-package') {
        this.fetchCoursePackage()
      }
      if (this.$route.name === 'course-users') {
        this.fetchSearchUsers()
      }
      if (this.$route.name === 'campaign-detail') {
        this.fetchCampaignProducts()
      }
    },
    async updateUserRole(e) {
      if (this.$route.path.includes('university')) {
        await moocUsersProvider.updateUserRole(e)
        return false
      }
      await dadbanCourseProvider.updateUserRole(e)
    },
    updateUserSearch(value) {
      this.getData(this.handleCourseUsers(), value)
    },
    async getProductPrice() {
      if (this.$route.params.courseId) {
        const req = await dadbanCourseProvider.getCourse(+this.$route.params.courseId)
        this.productPrice = req.data.data.output.price
        console.log(this.productPrice)
      }
      if (this.$route.params.packageId) {
        const req = await dadbanPackageProvider.getPackage(+this.$route.params.packageId)
        this.productPrice = req.data.data.output.price
      }
    },
  },
  computed: {
    routeParam() {
      if (this.$route.params.courseId || this.$route.params.packageId) {
        return this.route.path
      }
      return this.$route.params.slug
    },
    route() {
      return this.$route
    },
    headerItems() {
      return [
        {
          text: 'داشبورد',
          href: '/',
        },
        {
          text: this.dataList.data.name,
          active: true,
        },
      ]
    },
    exceptionsRoute() {
      if (this.$route.name === 'courses-package') {
        return true
      }
      if (this.$route.name === 'campaign-detail') {
        return true
      }
      if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        return true
      }
      if (this.$route.name === 'course-prerequisites') {
        return true
      }
      if (this.$route.name === 'package-prerequisites') {
        return true
      }
      if (this.$route.name === 'course-users') {
        return true
      }
      if (this.$route.name.startsWith('comments')) {
        return true
      }
      return false
    },
  },
  watch: {
    // $route(f) {
    //   console.log(f)
    //   if (f.path === '/list/totalcomments') {
    //     let queryParams = this.handleComments()
    //     setTimeout(() => {
    //       this.getData(queryParams)
    //     }, 1000)
    //   }
    // },
    '$route.query.query'(c) {
      console.log(this.$route.name)

      if (this.$route.name.startsWith('comments')) {
        let queryParams = this.handleCourseComments(this.$route)
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'courses-package') {
        let queryParams = this.handlePackegeCourses()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'campaign-detail') {
        this.fetchCampaignProducts()
      } else if (this.$route.name === 'course-prerequisites') {
        let queryParams = this.handleCoursePrerequisites()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'mooc-issuance-certificate') {
        let queryParams = this.handleIssuanceOfACertificate()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'package-prerequisites') {
        let queryParams = this.handlePackagePrerequisites()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'course-users') {
        let queryParams = this.handleCourseUsers()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.path === '/list/discount') {
        let queryParams = this.handleDiscountList()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.path === '/list/percentorderwithpagination') {
        let queryParams = this.handleReporting()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        let queryParams = this.handleDiscountDetail()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      }
    },
    '$route.name'(c) {
      if (c === 'course-users') {
        const queryParams = this.handleCourseUsers()
        this.getData(queryParams)
        return false
      }
    },
    '$route.query.perPage'() {
      if (this.$route.name === 'course-users') {
        const queryParams = this.handleCourseUsers()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'courses-package') {
        const queryParams = this.handlePackegeCourses()
        this.getData(queryParams)
        return false
      }
      // if (this.$route.path === '/list/totalcomments') {
      //   const queryParams = this.handleComments()
      //   this.getData(queryParams)
      //   return false
      // }
      if (this.$route.name === 'mooc-issuance-certificate') {
        const queryParams = this.handleIssuanceOfACertificate()
        this.getData(queryParams)
        return false
      }
      if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        let queryParams = this.handleDiscountDetail()
        setTimeout(() => {
          this.getData(queryParams)
          return false
        }, 1000)
      }

      if (this.$route.path === '/list/discount') {
        let queryParams = this.handleDiscountList()
        this.getData(queryParams)
        return false
      }
    },
    '$route.query.pageNumber'() {
      if (this.$route.name === 'course-users') {
        const queryParams = this.handleCourseUsers()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'courses-package') {
        const queryParams = this.handlePackegeCourses()
        this.getData(queryParams)
        return false
      }
      if (this.$route.path === '/list/totalcomments') {
        const queryParams = this.handleComments()
        this.getData(queryParams)
        return false
      }
      if (this.$route.name === 'mooc-issuance-certificate') {
        const queryParams = this.handleIssuanceOfACertificate()
        this.getData(queryParams)
        return false
      }
      if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        let queryParams = this.handleDiscountDetail()
        setTimeout(() => {
          this.getData(queryParams)
          return false
        }, 1000)
      }

      if (this.$route.path === '/list/discount') {
        let queryParams = this.handleDiscountList()
        this.getData(queryParams)
        return false
      }
    },
    routeParam(newValue, oldValue) {
      console.log(newValue, oldValue)
      this.prevRoute = `/list/${oldValue}`

      if (this.$route.name.startsWith('comments')) {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleCourseComments(this.$route)
        this.getData(queryParams)
      } else if (this.$route.name === 'courses-package') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handlePackegeCourses()
        this.getData(queryParams)
      } else if (this.$route.name === 'campaign-detail') {
        this.loading = false
        this.tableLoading = false
        let queryParams = this.handleCampaignProducts()
        this.getData(queryParams)
      } else if (this.$route.name === 'course-prerequisites') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleCoursePrerequisites()
        this.getData(queryParams)
      } else if (this.$route.name === 'package-prerequisites') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handlePackagePrerequisites()
        this.getData(queryParams)
      } else if (this.$route.path === '/list/totalcomments') {
        let queryParams = this.handleComments()
        setTimeout(() => {
          this.getData(queryParams)
        }, 1000)
      } else if (this.$route.name === 'course-users') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleCourseUsers()
        this.getData(queryParams)
      } else if (this.$route.name === 'mooc-issuance-certificate') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleIssuanceOfACertificate()
        this.getData(queryParams)
      } else if (this.$route.path === '/list/discount') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleDiscountList()
        this.getData(queryParams)
      } else if (this.$route.path === '/list/percentorderwithpagination') {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleReporting()
        this.getData(queryParams)
      } else if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        this.loading = false
        this.tableLoading = true
        let queryParams = this.handleDiscountDetail()
        this.getData(queryParams)
      } else if (newValue !== oldValue && this.$route.name !== 'transactions-fromListsWallet' && this.$route.name !== 'transactions-fromUserManagement') {
        let queryParams = {
          Key: newValue,
        }
        this.$store.dispatch('urlQueries/setSearchQuery', '')
        this.$store.dispatch('urlQueries/setCurrentPage', 1)
        this.$store.dispatch('urlQueries/setFields', [])
        this.$store.dispatch('urlQueries/setPageSize: ', 10)
        this.$store.dispatch('lists/setDataList', [])
        this.getData(queryParams)
      } else if (this.$route.name === 'transactions-fromListsWallet' || this.$route.name === 'transactions-fromUserManagement') {
        let queryParams = {
          Key: '',
          search: '',
          pageSize: 10,
          pageNumber: 1,
          fieldSearchs: [
            {
              fieldName: 'UserId',
              type: 'string',
              text: this.selectedRow.items.items[6].value,
            },
            {
              fieldName: 'Coin',
              type: 'string',
              text: this.selectedRow.items.items[7].value,
            },
          ],
        }
        this.getData(queryParams)
      }
    },
    wannaExcel(val) {
      if (val === true) {
        this.excelDownload()
      }
    },
  },

  mounted() {
    const route = this.$route
    let queryParams = null
    let ListsType = route.params.slug
    let query = route.query.query ? route.query.query : ''
    let pageNumber = route.query.pageNumber ? route.query.pageNumber : 1
    let pageSize = route.query.perPage ? route.query.perPage : 10
    let filters = route.query.filters ? route.query.filters : null
    this.$store.dispatch('urlQueries/setSearchQuery', query)
    this.$store.dispatch('urlQueries/setCurrentPage', pageNumber)
    this.$store.dispatch('urlQueries/setFields', filters)
    this.$store.dispatch('urlQueries/setPageSize', pageSize)
    if (this.$route.path.includes('users')) {
      this.getProductPrice()
    }
    if (route.name.startsWith('comments') || route.path.includes('/list/comments')) {
      queryParams = this.handleCourseComments(route)
      this.getData(queryParams)
      return false
    }
    if (route.name === 'courses-package') {
      queryParams = this.handlePackegeCourses()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'campaign-detail') {
      queryParams = this.handleCampaignProducts()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'course-prerequisites') {
      queryParams = this.handleCoursePrerequisites()
      this.getData(queryParams)
      return false
    }
    if (route.path === '/list/discount') {
      queryParams = this.handleDiscountList()
      this.getData(queryParams)
      return false
    }
    if (route.path === '/list/percentorderwithpagination') {
      queryParams = this.handleReporting()
      this.getData(queryParams)
      return false
    }
    if (route.path === '/list/totalcomments') {
      queryParams = this.handleComments()
      this.getData(queryParams)
      return false
    }
    if (route.path === '/list/discount/add' || route.path === '/list/discount/detail/' + route.params.id) {
      queryParams = this.handleDiscountDetail()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'package-prerequisites') {
      queryParams = this.handlePackagePrerequisites()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'course-users') {
      queryParams = this.handleCourseUsers()
      this.getData(queryParams)
      return false
    }
    if (route.name === 'mooc-issuance-certificate') {
      queryParams = this.handleIssuanceOfACertificate()
      this.getData(queryParams)
      return false
    }
    filters != undefined ? (filters = filters.split(',')) : []

    queryParams = {
      Key: ListsType,
      query: query,
      filters: filters,
      pageNumber: parseInt(pageNumber),
      pageSize: parseInt(pageSize),
    }

    this.getData(queryParams)
  },
  beforeDestroy() {
    this.$store.dispatch('lists/setDataList', [])
  },
}
</script>
<template>
  <div>
    <Toast v-if="!exceptionsRoute" :title="toastText" :error="toastMode" :showToast="showToast" :key="toastKey" />
    <div v-if="!loading">
      <PageHeader v-if="!exceptionsRoute && dataList.data" :title="dataList.data.name" :items="headerItems" />
      <Reporting v-if="$route.path === '/list/percentorderwithpagination'" @onSearch="onSearch" :loading="tableLoading" />

      <div class="row" v-if="dataList.data && dataList.data.extra">
        <div class="col-3 mb-3" v-for="(card, idx) in dataList.data.extra.data" :key="idx">
          <div class="card">
            <div class="card-body py-3 px-2">
              <div class="extraMainDiv d-flex align-items-center justify-content-between">
                <div class>{{ dataList.data.extra.data[idx].title }}</div>
                <div class="descCard" data-bs-toggle="tooltip" :title="Commafy(dataList.data.extra.data[idx].description)" :style="`color:${dataList.data.extra.data[idx].color}`">
                  {{ Commafy(dataList.data.extra.data[idx].description) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <IvitationSetting v-if="IvitationSettingModel" :key="modalKey" :earlyData="followUpData" />
      <div class="row">
        <BlackListModal v-if="BlackListModel" :key="BlackListKey" />
        <template v-if="this.route.name.startsWith('comments')">
          <CommentsSideCard :route="$route" />
        </template>
        <div class="col">
          <div v-if="!tableLoading">
            <div class="card">
              <div class="card-body p-card-body" :class="{ focused }">
                <TableHeader
                  v-if="(dataList.data && dataList.data.addRowPage) || ['/list/discount/add', `/list/discount/detail/${$route.params.id}`].includes($route.path)"
                  :isActive="false"
                  searchVisible
                  :list="list"
                  :button="dataList.data.addRowPage && dataList.data.addRowPage.title && !$route.path.includes('/list/totalcomments') ? true : false"
                  :buttonTitle="dataList.data.addRowPage && dataList.data.addRowPage.title ? dataList.data.addRowPage.title : ''"
                  :buttonFunction="addRow"
                  actionClass="d-flex align-items-center justify-content-between"
                  :notDropdown="true"
                  :getData="getData"
                  @invitaionSetting="invitaionSetting($event)"
                  @blackList="blackListSetting"
                  @focused="handleSearchFocus"
                  @update="updateData"
                  :productPrice="productPrice"
                  :settingBtn="dataList.data.addRowPage && dataList.data.addRowPage.key === 'invitation' ? true : false"
                />

                <Table
                  v-if="(dataList.data && dataList.data.addRowPage) || $route.path === '/list/discount/add' || $route.path === '/list/discount/detail/' + $route.params.id"
                  :key="componentKey"
                  :titleVisible="true"
                  :descriptionVisible="true"
                  :filterVisible="true"
                  :changeGrid="true"
                  :selectRoute="dataList.data.addRowPage && dataList.data.addRowPage.link && `${dataList.data.addRowPage.link}/detail`"
                  :clickToChangeRoute="true"
                  :noNeedToChangeRoute="
                    !dataList.data.addRowPage ? true : dataList.data.addRowPage.link == null || (exceptionsRoute && !$route.name.startsWith('comments')) ? true : false
                  "
                  @deleteRow="deleteRow"
                  @updateRole="updateUserRole"
                  @updateUserSearch="updateUserSearch"
                  :title="dataList.name"
                  description="تست"
                  :selectOption="true"
                  hover="true"
                  :fields="fields"
                  :rows="rows"
                  @selected="(e) => $emit('selected', e)"
                  @selectedRow="rowSelected"
                  :checkedList="checkedList"
                  :productPrice="productPrice"
                >
                  <template v-slot:emptyTable>
                    <Loader :loading="dotLoading" />
                  </template>
                </Table>

                <Pagination
                  v-if="dataList && dataList.pagination && dataList.pagination.totalPages && dataList.pagination.totalPages > 1"
                  :paginationData="dataList.pagination"
                  :dropDownListItems="dropDownListItems"
                  :getData="getData"
                >
                  <template v-if="!exceptionsRoute" v-slot:excel>
                    <Excel :link="downloadLink" @downloadExcel="wannaExcel = $event" />
                  </template>
                </Pagination>
              </div>
            </div>
          </div>
          <Loader v-if="tableLoading" :loading="tableLoading" />
        </div>
      </div>
    </div>
    <Loader v-if="loading" :loading="loading" />
    <AddCategory :category="categoryData" @update="getData(handlePage())" />
    <HomeCategoryModal :homeCategory="homeCategoryData" @update="getData(handleHomeCategory())" />
    <TeacherValidationModal />
  </div>
</template>

<style scoped>
@import url('./index.css');
</style>
